import React from "react";
import { useCookies } from "react-cookie";
import { css } from "@emotion/react";
import PropTypes from "prop-types";

import RevueNewsletter from "./revueNewsletter";
import popupImage from "../images/multicolor-woman-with-map.svg";
import { baseColor2 } from "../styles/color";
import { breakpointSm } from "../styles/layout";
import { CloseRounded } from "@material-ui/icons";

const popupStyles = css`
  .exit-intent-popup {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: grid;
    place-items: center;
    z-index: 1;
    background: rgba(33, 33, 33, 0.8);
    transform: translateY(60%) scale(0);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .exit-intent-popup.visible {
    transform: translateY(0) scale(1);
  }

  .newsletter {
    position: relative;
    padding: 1.5rem 1rem;
    background: ${baseColor2};
    border-radius: 0.5rem;
    max-width: 536px;
  }

  .newsletter-grid {
    display: grid;
    grid-template-columns: 4fr 1fr;
    gap: 1rem;
  }

  .text-block {
    h3 {
      font-size: 1.5rem;
      line-height: 1;
      margin: 0 0 0.75rem 0;
    }

    p {
      font-size: 1.25rem;
      line-height: 1.2;
      margin: 0;
    }
  }

  .newsletter-image {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .image-block {
    display: none;
  }

  .close {
    position: absolute;
    top: 0.25rem;
    right: 0.25rem;
    cursor: pointer;
    transform: scale(0.8);
  }

  @media only screen and (max-width: ${breakpointSm}) {
    .newsletter {
      max-width: 365px;
      margin: 0 0.5rem;
    }

    .newsletter-grid {
      grid-template-columns: 1fr;
      gap: 0;
    }

    .internal-grid {
      display: grid;
      grid-template-columns: 4fr 1fr;
      gap: 10px;
    }

    .image-block {
      display: inline;
      align-self: end;
    }

    .newsletter-image {
      display: none;
    }

    img {
      height: 100%;
      width: 100%;
    }
  }
`;

const Popup = (props) => {
  const [cookies, removeCookie] = useCookies(["sref"]);
  const exit = (e) => {
    const shouldExit =
      e === true || // works with Mui Icon
      [...e.target.classList].includes("exit-intent-popup") || // user clicks on mask
      e.target.className === "close" || // user clicks on the close icon
      e.keyCode === 27; // user hits escape

    if (shouldExit) {
      document.querySelector(".exit-intent-popup").classList.remove("visible");
      // Delete the cookie so we don't trigger the popup again
      removeCookie("sref", { path: "/" });
    }
  };

  // If cookies.sref is undefined, that means this is the user's first time here.
  // Also if we have triggered this event before (i.e the user already hit the main page)
  // then don't add another event.
  if ((cookies.sref ? false : true) && !props.eventTriggered) {
    setTimeout(() => {
      document.querySelector(".exit-intent-popup").classList.add("visible");
      document.addEventListener("keydown", exit);
      document
        .querySelector(".exit-intent-popup")
        .addEventListener("click", exit);
    }, 5000);
  }

  return (
    <div css={popupStyles}>
      <div className="exit-intent-popup">
        <div className="newsletter">
          <CloseRounded
            className="close"
            onClick={() => {
              exit(true);
            }}
          />
          <div className="newsletter-grid">
            <div className="newsletter-content">
              <div className="internal-grid">
                <div className="text-block">
                  <h3>
                    <span className="blue">Find</span>{" "}
                    <span className="pink">a</span>{" "}
                    <span className="yellow">meaningful</span>{" "}
                    <span className="green">career</span>{" "}
                  </h3>
                  <p>
                    Get top social impact job opportunities each week with our
                    curated newsletter.
                  </p>
                </div>
                <div className="image-block">
                  <img src={popupImage} alt="Woman with map" />
                </div>
              </div>
              <RevueNewsletter newsletterLocation="popup" />
            </div>
            <div className="newsletter-image">
              <div className="main-image">
                <img src={popupImage} alt="Woman with map" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Popup.defaultProps = {
  eventTriggered: false,
};

Popup.propTypes = {
  eventTriggered: PropTypes.bool,
};

export default Popup;
